import React from 'react'

export const ListHead = () => {
  return (
    <thead>
      <tr>
        <th style={{ width: '10px' }} />
        <th>Template</th>
      </tr>
    </thead>
  )
}
